import Logger from './Logger';
import Features from './Features';

function fetchNewScript() {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = false;
    script.src =
      '//staticw2.yotpo.com/MtI6WMUc1SMDm8DW3ZmRDSTA4TUsLomtzi81ZY7C/widget.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
    script.addEventListener('load', () => {
      resolve('Loaded');
    });
    document.head.appendChild(script);
  });
}

async function fetchNewScriptAndConsumeExceptions() {
  return fetchNewScript().catch((err) => {
    Logger.warn(
      'Yotpo could not be initialized with fetchNewScript. Moving on.',
      err,
    );
  });
}

let promotedProductsObserver = null;
let rafPending = false;

function patchPromotedProductLinks() {
  document.querySelectorAll('a.pp-card-link').forEach((link) => {
    if (link.textContent.trim() || !link.getAttribute('aria-label')) return;
    const span = document.createElement('span');
    span.textContent = link.getAttribute('aria-label');
    span.style.cssText =
      'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0)';
    link.appendChild(span);
  });
}

function stopObservingPromotedProducts() {
  if (promotedProductsObserver) {
    promotedProductsObserver.disconnect();
    promotedProductsObserver = null;
  }
}

function observeAndPatchPromotedProducts() {
  stopObservingPromotedProducts();
  patchPromotedProductLinks();
  promotedProductsObserver = new MutationObserver(() => {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(() => {
        patchPromotedProductLinks();
        rafPending = false;
      });
    }
  });
  promotedProductsObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function runScriptWhenIdIsPresent(id) {
  if (document.getElementById(id)) {
    if (window.yotpo) {
      try {
        const refreshWidgets = window.yotpo
          ? window.yotpo.refreshWidgets.bind(window.yotpo)
          : () => {};
        refreshWidgets();
        if (Features.featureIsEnabled('consumer-fixyotpocarosel-css')) {
          observeAndPatchPromotedProducts();
        }
      } catch (err) {
        Logger.warn(
          'Yotpo could not be initialized with runScriptWhenIdIsPresent. Moving on.',
          err,
        );
      }
    } else {
      return fetchNewScriptAndConsumeExceptions().then(() => {
        if (Features.featureIsEnabled('consumer-fixyotpocarosel-css')) {
          observeAndPatchPromotedProducts();
        }
      });
    }
  }

  return false;
}

async function initializeScript() {
  if (!window.yotpo) {
    return fetchNewScriptAndConsumeExceptions();
  }

  return false;
}

export default {
  runScriptWhenIdIsPresent,
  initializeScript,
  patchPromotedProductLinks,
  observeAndPatchPromotedProducts,
  stopObservingPromotedProducts,
};
